import React from 'react';
import PureComponent from 'react-pure-render/component';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { loadEvent, setHeader } from 'actions';
import shallowEqual from 'react-pure-render/shallowEqual';
import has from 'lodash/has';
import findIndex from 'lodash/findIndex';
import auth from 'lib/Auth';

import Loading from 'components/common/Loading';
import EventDetails from 'components/calendar/EventDetails';
import Icon from 'components/common/Icon';

class EventDetailPage extends PureComponent {
  static loadData(props) {
    const { event_id } = props;
    props.loadEvent(event_id);
  }

  static updateHeader(props) {
    const { event } = props;
    let rightAction;

    // if (has(event, 'metadata.actions.admin') && event.type) {
    //   if ((event.type.id === 1 || event.type.id === 6) && findIndex(event.metadata.actions.admin, check => check.text === 'Edit') !== -1) {
    //     rightAction = <Link to={`/calendar/edit/${event.id}`}>Edit</Link>;
    //   }
    // }

    let subscribe_url = '';

    if(has(props, 'event_id')) {
      subscribe_url = `${window.API_ROOT}?type=export&action=ical&id=${props.event_id}`;
    }

    let subscribeIcon;

    if(subscribe_url.length > 0) {

      let subscribeUrl_out = unescape(subscribe_url);

      if(subscribeUrl_out.substr(0, 4) != 'http' && subscribeUrl_out.substr(0, 1) != '/') subscribeUrl_out = '/' + subscribeUrl_out;

      if (has(event, 'user_viewing_groups') && event.user_viewing_groups && event.user_viewing_groups.length > 0) {
        subscribeUrl_out = auth.getAuthURL(subscribeUrl_out);
      }

      subscribeIcon = (    
            <a
              style={{
                fontSize: 12,
                padding: 8,
                opacity: 0.8,
              }}
              href={`${subscribeUrl_out}`}
            >
              <Icon
                icon="calendar-add"
                size="medium"
                style={{
                  
                }}
              />
            </a>);
    }

    props.setHeader('Event Details', (prevRoute) => {
      const { pathname } = prevRoute;

      if (!pathname) {
        return '/calendar';
      } else if (pathname.indexOf('/handleToken') !== -1) {
        return '/calendar';
      } else if (pathname.indexOf('add') === -1 && pathname.indexOf('edit') === -1) {
        return true;
      }
      return '/calendar';
    }, (prevRoute) => {
      const { pathname } = prevRoute;

      if (!pathname) {
        return '';
      }
      if (pathname.indexOf('page') !== -1 && pathname.indexOf('view') !== -1) {

        let pageTitle = 'Report';

        if (has(window.CONFIG, 'enable_reports') && has(window.CONFIG, 'rename_schedules_to_reports')) {
          if (window.CONFIG.enable_reports === '1' && window.CONFIG.rename_schedules_to_reports === '2') {
            pageTitle = 'Page';
          } else if (window.CONFIG.enable_reports === '1' && window.CONFIG.rename_schedules_to_reports === '1') {
            pageTitle = 'Report';
          } else if (window.CONFIG.enable_reports === '1') {
            pageTitle = 'Schedule';
          }
        }

        return pageTitle;
      } else if (pathname.indexOf('schedule') !== -1 && pathname.indexOf('view') !== -1) {
        return 'Schedule';
      } else if (pathname.indexOf('calendar') !== -1 && pathname.indexOf('details') !== -1) {
        return 'Event';
      }
      return '';
    }, subscribeIcon);
  }

  state = {}

  componentWillMount() {
    EventDetailPage.loadData(this.props);
    EventDetailPage.updateHeader(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.event_id && nextProps.event_id !== this.props.event_id) {
      EventDetailPage.loadData(nextProps);
    }

    if (nextProps.event && !shallowEqual(nextProps.event, this.props.event)) {
      EventDetailPage.updateHeader(nextProps);
    }
  }

  render() {
    const { event } = this.props;

    if (!event || event.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    if (event && !event.isLoading && !event.labels) {
      return (
        <div className="centered" style={{ minHeight: 200 }}>
          <Link to="/calendar">View Calendar</Link>
        </div>
      );
    }

    return (
      <EventDetails event={event} />
    );
  }
}

function mapStateToProps(state) {
  const { event_id } = state.router.params;
  const event = state.calendar.events.all[event_id];
  
  return {
    event_id,
    event,
  };
}

export default connect(mapStateToProps, {
  loadEvent,
  setHeader,
})(EventDetailPage);



// WEBPACK FOOTER //
// ./src/app/containers/EventDetailPage.js